import { render, staticRenderFns } from "./PromotionGuidelines.vue?vue&type=template&id=7df3828c&scoped=true"
import script from "./PromotionGuidelines.vue?vue&type=script&lang=js"
export * from "./PromotionGuidelines.vue?vue&type=script&lang=js"
import style0 from "./PromotionGuidelines.vue?vue&type=style&index=0&id=7df3828c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df3828c",
  null
  
)

export default component.exports